module.exports = __webpack_public_path__ + "img/food_burger.e6d293c1.png";